import Mgr from "./oidcConfig";

export default {
    mgr: new Mgr(),
    token: '',
};